export const locale = {
    lang: "es-ES",
    data: {
        TOOLBAR: {
            CHANGE_PASSWORD: "Cambiar contraseña",
            LOGOUT: "Cerrar sesión",
            HELP: "Ajuda"
        }
    }
};
